"use client";

import type { ReactNode } from "react";

type BackendPageHeaderPropsT = {
  title: string;
  backHref?: string;
  children?: ReactNode;
};

export function BackendPageHeader({
  title,
  children,
}: BackendPageHeaderPropsT) {
  return (
    <div
      className="backend-page-header relative pt-3 pb-6"
      data-backend-page-header="true"
    >
      <div className="min-w-0 flex-1 lg:pr-[min(48vw,560px)]">
        <h1
          className="text-[32px] leading-tight font-semibold"
          style={{ fontFamily: "var(--font-backend-serif)" }}
        >
          {title}
        </h1>
        <div
          className="mt-2 empty:hidden"
          data-backend-page-header-status-slot="true"
        >
          {children}
        </div>
      </div>
      <div
        className="mt-4 flex justify-end empty:hidden lg:absolute lg:top-3 lg:right-0 lg:mt-0 lg:max-w-[min(52vw,760px)]"
        data-backend-page-header-actions-slot="true"
      />
    </div>
  );
}
